import getters from './getters';
import mutations from './mutations';

const state = () => ({
  firstCard: false,
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
